import { render, staticRenderFns } from "./ZDropdownAdmins.vue?vue&type=template&id=6264483e&"
import script from "./ZDropdownAdmins.vue?vue&type=script&lang=js&"
export * from "./ZDropdownAdmins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports